import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { LocalStorageVariables, Themes } from '../../shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private themeSubject = new BehaviorSubject<Themes>(Themes.LIGHT)
  public theme$: Observable<Themes> = this.themeSubject.asObservable()

  constructor(private logger: DdcLoggerService) {
    this.initializeTheme()
  }

  private initializeTheme(): void {
    this.logger.info('THEME | initializeTheme')
    const theme = localStorage.getItem(LocalStorageVariables.THEME)
    if (theme) {
      this.themeSubject.next(theme as Themes)
    }
  }

  set(theme: Themes): void {
    this.logger.info('THEME | set | theme: ' + theme)
    localStorage.setItem(LocalStorageVariables.THEME, theme)
    this.themeSubject.next(theme) // Notify subscribers of the theme change
  }

  get currentTheme(): string {
    this.logger.info('THEME | currentTheme')
    let theme = localStorage.getItem(LocalStorageVariables.THEME)
    if (!theme) return Themes.LIGHT

    return theme
  }
}
